import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import FaultStatistics from '../components/monitor/FaultStatistics';

const App = ({ intl, dispatch, loading, fault, monitor, account }) => {
  return (
    <div className="container-left">
      <FaultStatistics
        intl={intl}
        dispatch={dispatch}
        loading={loading}
        fault={fault}
        monitor={monitor}
        account={account}
      />
    </div>
  );
};

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(App)
);



// WEBPACK FOOTER //
// ./src/routes/FaultStatistics.js